/**
 * Created by chenjia on 2017/4/5.
 */
const specialChooseModel = require("../model/specialChooseModel/specialChooseModel");
const tabModel = require("../model/tabModel/tabModel");
const tplModel = require('../model/tplModel/tplModel');
const price = require('../unit/price/price');
const login = require('../unit/isLogin/isLogin');
const tapEvent = require('../unit/tapEvent/tapEvent');
const Config = require("../Config/Config");

const REQUEST_NUM = 20;
let pageNum = 1;
let isClze = 2;
let isScrollEnd = false;

function getUrlParam(name) {
  // 获取URL参数
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
}



let specialChooseModule = {
    init: function () {
        this.getFlagImg();
        this.getCommentNum();
        this.addEvent();
        this.initConcern();
    },
    addEvent: function () {
        let self = this;
        //最IN尖货swiper
        let isLoop = true;
        let noSwiping = false;
        let pagination = '.swiper-pagination';

        let itemNum = $("#recommendSwiper .block").length;
        if (itemNum === 1) {
            isLoop = false;
            noSwiping = true;
            pagination = false;
        }
        let recommendSwiper = new Swiper("#recommendSwiper", {
            slidesPerView: 1.34,
            loop: isLoop,
            loopAdditionalSlides: 2,
            pagination: pagination,
            autoplay: 3000,
            autoplayDisableOnInteraction: false,
            noSwiping: noSwiping,
            noSwipingClass: 'block'
        });

        //分类京选swiper
        let rootFontSize = $("html").css("font-size");
        rootFontSize = rootFontSize.substring(0, rootFontSize.length - 2);
        let offset = rootFontSize * 0.5;

        $(".classify-swiper").each(function (i) {
            let swiperId = "#classifySwiper" + (i + 1);

            let itemObj = $(swiperId + ".classify-swiper .item");
            let slideCount = itemObj.length;

            new Swiper(swiperId, {
                slidesPerView: 3.55,
                freeMode: true,
                lazyLoading: true,
                lazyLoadingInPrevNext: true,
                lazyLoadingInPrevNextAmount: 5,
                slidesOffsetBefore: offset,
                slidesOffsetAfter: offset,
                onTouchEnd: function (swiper) {
                    if ($(swiperId).find(".item-end").length > 0) {
                        let url = $(swiperId).find(".item-end").attr("data-href");
                        let itemWidth = swiper.slides[0].clientWidth;
                        let pxMoveToOpenPage = slideCount * itemWidth + itemWidth / 2 - (18.75 * rootFontSize);
                        if (swiper.getWrapperTranslate('x') * -1 >= pxMoveToOpenPage) {
                            window.location.href = url;
                        }
                    }
                }
            });
        });

        //tab页swiper
        let slideNum = $(".jxTabs").find("dd").length;
        switch (slideNum) {
            case 1:
                slideNum = 1;
                break;
            case 2:
                slideNum = 2;
                break;
            case 3:
                slideNum = 3;
                break;
            case 4:
                slideNum = 4;
                break;
            default:
                slideNum = 4.4;
        }
        
        window.newSwiper=new Swiper(".tabBg", {
            slidesPerView: slideNum,
            spaceBetween: 0,
            freeMode: true,
            // initialSlide: initialSlide,
            freeModeSticky: false,
            slidesOffsetBefore: offset,
            onInit: function (swiper) {
              self.addTabsEvent(swiper);
              var activeCateId=getUrlParam('activeCateId');
              if(activeCateId){
                $(".jxTabs .tabBg .swiper-slide[cateId='"+activeCateId+"']").trigger('touchend')
              }
            }
        });

        //关注
        tapEvent.handleTap(".moreChoose .right", (_this) => {
            login.isLogin((data) => {
                if (data.isLogin == true) {
                    let concernObj = $(_this).find(".concern");
                    let skuid = $(_this).parents(".item").find(".left").attr("skuid");
                    //已登录
                    if (!concernObj.hasClass("selected")) {
                        //关注
                        self.attentionItem(skuid);
                    } else if (concernObj.hasClass("selected")) {
                        //取消关注
                        self.unAttentionItem(skuid);
                    }
                } else if (data.isLogin == false) {
                    //未登录
                    let currUrl = location.href;
                    let loginUrl = data.loginUrl;
                    window.location.href = loginUrl + currUrl;
                }
            });
        });
    },
    addTabsEvent: function (swiper) {
        let self = this;

        tabModel.tapEvent(".jxTabs .tabBg dd", self.tapStart, "", self.defaultCallback_end, swiper);

        let timeout = null;
        $(window).on("scroll", function () {

            let tabObj = $(".jxTabs");
            //tab置顶
            if (tabObj.find(".tabBg").length !== 0) {
                let tabCntObj = tabObj.find(".tab-cnt");
                if (tabCntObj.length === 0) {
                    return false;
                }
                let tabHeight = tabObj.find(".tabBg").height();
                let tabCntOffset = tabCntObj.offset().top - tabHeight;
                let maxOffset = tabCntOffset + tabCntObj.height();

                if ($("body").scrollTop() > tabCntOffset && $("body").scrollTop() < maxOffset) {
                    tabObj.addClass("tab-fixed");
                } else {
                    tabObj.removeClass("tab-fixed");
                }
            }

            //分类页滚动加载更多
            if (tabObj.find(".list-over").length === 0 && tabObj.parent().hasClass("classifyChoose") && $(".classifyChoose .tab-cnt li").length >= REQUEST_NUM && !Config.lock && !isScrollEnd) {
                let scrollToLoadHeight = $(document).height() - 400;
                if ($(window).scrollTop() + $(window).height() >= scrollToLoadHeight && Config.lock === false) {
                    $(".classifyChoose .tab-cnt").append(`
                        <div class="loading">
                            <i></i>
                            <div class=txt>加载中</div>
                        </div>
                    `);

                    pageNum++;
                    isClze = 1;
                    let moduleId = tabObj.find("dl .curr").attr("cateid");
                    let sign = $("#sign").val();
                    let index = parseInt(tabObj.find("dl .curr").index()) + 1;
                    let args = {
                        "moduleId": moduleId,
                        "pageNum": pageNum,
                        "isClze": isClze,
                        "sign": sign
                    };
                    Config.lock = true;

                    specialChooseModel.ajaxGetCategorySkus(args, function (data) {
                        Config.lock = false;
                        $(".classifyChoose .loading").remove();

                        data.isClassifyPage = true;
                        data.index = index;
                        data.pageNum = pageNum - 1;
                        data.moduleId = moduleId;
                        if (data.skus) {
                            renderItems(data);

                            if (data.skus.length < REQUEST_NUM) {
                                addNoMoreTips();
                            }
                        } else {
                            addNoMoreTips();
                        }
                    }, function () {
                        Config.lock = false;
                    });
                }
            }
        }).trigger("scroll");

        function addNoMoreTips() {
            isScrollEnd = true;
            $(".classifyChoose .tab-cnt").append(`
                                <div class="noMore">
                                    <div class=txt>没有更多了~</div>
                                </div>
                            `);
        }
    },
    getFlagImg: function () {
        let skuids = "";

        $(".moreChoose .item").each(function () {
            let skuid = $(this).attr("skuid");

            skuids += skuid + ",";
        });

        if (skuids === "") {
            return false;
        }

        skuids = skuids.substring(0, skuids.length - 1);

        let args = {
            "skuIds": skuids
        };
        specialChooseModel.ajaxGetFlagImg(args, function (data) {
            for (let skuid in data) {
                let imgUrl = data[skuid];
                if (imgUrl && imgUrl !== null) {
                    let item = $(".moreChoose").find("[skuid='" + skuid + "']");
                    item.find(".conduct").addClass("hasFlag").append('<img src="' + imgUrl + '" class="countryFlag">');
                }
            }
        })
    },
    getCommentNum: function () {
        let items = $(".topSale .item");
        if (items.length === 0) {
            return false;
        }

        let skuids = "";
        items.each(function () {
            let skuid = $(this).attr("skuid");

            skuids += skuid + ",";
        });

        skuids = skuids.substring(0, skuids.length - 1);
        let args = {
            "skuIds": skuids
        };
        specialChooseModel.ajaxGetCommentNum(args, function (data) {
            for (let skuid in data) {
                let num = data[skuid];
                if (num !== "0") {
                    let item = $(".topSale").find("[skuid='" + skuid + "']");
                    item.find(".appraise").text("已获" + num + "好评");
                }
            }
        });
    },
    tapStart: function (e, self) {
        self.f.startX = e.touches[0].clientX;
        self.f.endX = e.touches[0].clientX;
        self.f.prevX = self.f.startX;
        self.f.prevY = e.touches[0].clientY;
        self.f.directionX = "";
        self.f.directionY = "";
    },
    defaultCallback_end: function (e, _this, self, selfObj) {

        if (self.f.directionY === "top" || self.f.directionY === "bottom" || self.f.directionX === "right" || self.f.directionX === "left") {
        } else {
            if (Config.lock) {
                return false;
            }

            isScrollEnd = false;

            loadData(_this);
            self.setPosition(_this, self, selfObj);

            if ($(".jxTabs").parent().hasClass("classifyChoose")) {
                setTimeout(function () {
                    $(window).scrollTop(0);
                }, 300);
            }
        }
    },
    initConcern: function () {
        let self = this;
        //初始化是否关注
        login.isLogin(function (data) {
            if (data.isLogin == true) {
                //已登录
                self.isAttention();
            } else if (data.isLogin == false) {
                //未登录
            }
        });
    },
    isAttention: function () {
        let skuids = "";
        $(".moreChoose .item").each(function () {
            let skuid = $(this).find(".itemImg").attr("skuid");
            skuids += skuid + ",";
        });

        skuids = skuids.substring(0, skuids.length - 1);

        let args = {
            "productIds": skuids,
            "oper": "isFollow"
        };

        specialChooseModel.ajaxAttentionProduct(args, (data) => {
            for (let skuid in data) {
                let isAttention = data[skuid];
                let itemObj = $(".moreChoose").find("[skuid='" + skuid + "']");
                if (isAttention) {
                    itemObj.find(".concern").addClass("selected");
                } else {
                    itemObj.find(".concern").removeClass("selected");
                }

            }
        });
    },
    attentionItem: function (skuid) {
        let args = {
            "productIds": skuid,
            "oper": "follow"
        };

        specialChooseModel.ajaxAttentionProduct(args, (data) => {
            if (data === true) {
                $(".moreChoose").find("[skuid='" + skuid + "'] .concern").addClass("selected");
            }
        });
    },
    unAttentionItem: function (skuid) {
        let args = {
            "productIds": skuid,
            "oper": "unFollow"
        };

        specialChooseModel.ajaxAttentionProduct(args, (data) => {
            if (data === true) {
                $(".moreChoose").find("[skuid='" + skuid + "'] .concern").removeClass("selected");
            }
        });
    }
};

let bannerTpl = `
    <div class="banner">
        <img src="<%=bannerImg%>" report-eventid="MGlobalJX_ClassBanner" report-eventparam="<%=moduleId%>" data-href="<%=bannerLink%>" class="bg tapSale J_ping" clstag="pageclick|keycount|jdworldwidemchooseclz|category_<%=index%>_banner">
    </div>
`;

let itemWrapperTpl = `
    <ul class="clearfix">
    </ul>
    <% if(!isClassifyPage && moreText != "") { %>
    <div class="moreWp">
        <div class="moreItem tapLink J_ping" data-href="<%=moreLink%>" clstag="pageclick|keycount|jdworldwidemchoose|cate_<%=index%>_more" report-eventid="MGlobalJX_HomeClassMore" report-eventparam="<%=moduleId%>">
            <div class="txt"><%=moreText%></div>
            <i class="before"></i>
            <i class="after"></i>
        </div>
    </div>
    <% } %>
`;

let itemTpl = `
    <% if(isClassifyPage == true) { %>
        <% for(var i=0; i<skus.length; i++) {%>
            <li skuid="<%=skus[i].sku%>" class="tapItem J_ping" report-eventlevel="4" clstag="pageclick|keycount|jdworldwidemchooseclz|category_<%=index%>_<%=(pageNum*20+(i+1))%>" report-eventid="MGlobalJX_HomeClassProduct" report-eventparam="<%=moduleId%>_<%=(pageNum*20+(i+1))%>_<%=skus[i].sku%>">
                <img src="<%=skus[i].skuImg%>" class="itemImg lazy">
                <span class="name"><%=skus[i].skuName%></span>
                <span class="price">
                    <span></span>
                    <del></del>
                </span>
            </li>
        <% } %>
    <% } else { %>
        <% if(skus.length % 2 == 1) { %>
            <% for(var i=0; i<skus.length - 1; i++) {%>
                <li skuid="<%=skus[i].sku%>" class="tapItem J_ping" report-eventlevel="4" clstag="pageclick|keycount|jdworldwidemchoose|cate_<%=index%>_<%=i+1%>" report-eventid="MGlobalJX_HomeClassProduct" report-eventparam="<%=moduleId%>_<%=i+1%>_<%=skus[i].sku%>">
                    <img src="<%=skus[i].skuImg%>" class="itemImg lazy">
                    <span class="name"><%=skus[i].skuName%></span>
                    <span class="price">
                        <span></span>
                        <del></del>
                    </span>
                </li>
            <% } %>
        <% } else { %>
            <% for(var i=0; i<skus.length; i++) {%>
                <li skuid="<%=skus[i].sku%>" class="tapItem J_ping" report-eventlevel="4" clstag="pageclick|keycount|jdworldwidemchoose|cate_<%=index%>_<%=i+1%>" report-eventid="MGlobalJX_HomeClassProduct" report-eventparam="<%=moduleId%>_<%=i+1%>_<%=skus[i].sku%>">
                    <img src="<%=skus[i].skuImg%>" class="itemImg lazy">
                    <span class="name"><%=skus[i].skuName%></span>
                    <span class="price">
                        <span></span>
                        <del></del>
                    </span>
                </li>
            <% } %>
        <% } %>
    <% } %>
`;

function loadData(_this) {
    _this.parent().children().removeClass("curr");
    _this.addClass("curr");

    let moduleId = _this.attr("cateid");
    pageNum = 1;
    isClze = 2;
    if ($(".jxTabs").parent().hasClass("classifyChoose")) {
        isClze = 1;
    }
    let sign = $("#sign").val();
    let args = {
        "moduleId": moduleId,
        "pageNum": pageNum,
        "isClze": isClze,
        "sign": sign
    };
    Config.lock = true;
    specialChooseModel.ajaxGetCategorySkus(args, function (data) {
        Config.lock = false;
        $(".jxTabs .tab-cnt").html("");

        let isClassifyPage = false;
        let moreLink = "";
        let moreText = "";
        let index = parseInt(_this.index()) + 1;
        if ($(".jxTabs").parent().hasClass("classifyChoose")) {
            isClassifyPage = true;
        } else {
            if (data.more) {
                moreLink = data.more.moreLink;
                moreText = data.more.moreText;
            }
        }
        data.index = index;
        if (isClassifyPage && data.banner) {
            data.banner.index = index;
            data.banner.moduleId = moduleId;
            renderBanner(data.banner);
        }

        if (data.skus) {
            let wrapperData = {
                "moreLink": moreLink,
                "moreText": moreText,
                "isClassifyPage": isClassifyPage,
                "index": index,
                "moduleId": moduleId
            };

            renderItemWrapper(wrapperData);
            data.isClassifyPage = isClassifyPage;
            data.pageNum = pageNum - 1;
            data.moduleId = moduleId;
            renderItems(data);
        }

    }, function () {
        Config.lock = false;
    });

}

function renderBanner(bannerData) {
    let render = template.compile(bannerTpl);
    let bannerHtml = render(renderData);
    $(".jxTabs .tab-cnt").prepend(bannerHtml);
}

function renderItemWrapper(wrapperData) {
    let render = template.compile(itemWrapperTpl);
    let itemWrapperHtml = render(wrapperData);
    $(".jxTabs .tab-cnt").append(itemWrapperHtml);
}

function renderItems(itemData) {
    let render = template.compile(itemTpl);
    if(itemData.skus){
      itemData.skus=sliceSkus(itemData.skus);
    }
    let itemHtml = render(itemData);
    $(".jxTabs .tab-cnt ul").append(itemHtml);
    price.fn.init();
    tapEvent.tapItem();
    tapEvent.tapSale();
    tapEvent.tapLink();
}

function sliceSkus(skus){
  // 取page-size进行分页数据切割
  var newSkus=[];
  var $jxTabs=$('.jxTabs');

  if($jxTabs.length>0 && $jxTabs.attr('page-size')){
    var pageSize=parseInt($jxTabs.attr('page-size'),10);
    var length=skus.length>pageSize ? pageSize : skus.length;
    return skus.slice(0,length);
  }else{
    return skus
  }
}


module.exports = specialChooseModule;



// WEBPACK FOOTER //
// ./src/js/module/specialChooseModule.js